module.exports = __webpack_public_path__ + "static/media/gts18.b1826c41.png";